/* Vegan LifeMoss homepage interactions: tabs, subscribe toggles, add to cart, bundles, code buttons, review scroll, videos. */
(function () {
  'use strict';
  if (window.__vlmHomeLoaded) return;
  window.__vlmHomeLoaded = true;
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  function fmt(cents) {
    return '$' + (Math.round(cents) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function note(text) {
    var el = document.createElement('div');
    el.setAttribute('role', 'alert');
    el.textContent = text;
    el.style.cssText = 'position:fixed;left:50%;bottom:90px;transform:translateX(-50%);z-index:2147483002;background:#222;color:#fff;padding:12px 18px;border-radius:10px;font:600 14px Manrope,Arial,sans-serif;max-width:90vw';
    document.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 4000);
  }
  function refreshCart() {
    try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) {}
  }
  function openCart() {
    try {
      if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
      if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); return; }
    } catch (e) {}
    window.location.href = root + 'cart';
  }
  function applyCode(code) {
    return fetch(root + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
  }
  function add(items, btn, code) {
    var label = btn.innerHTML;
    btn.disabled = true;
    return fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return code ? applyCode(code) : null; })
      .then(function () {
        btn.disabled = false;
        btn.innerHTML = 'ADDED ✓';
        setTimeout(function () { btn.innerHTML = label; }, 2500);
        openCart();
      })
      .catch(function (err) {
        btn.disabled = false;
        note((err && (err.description || err.message)) || 'Sorry, that could not be added to your cart.');
      });
  }

  function initTabs(box) {
    var tabs = Array.prototype.slice.call(box.querySelectorAll('[data-vh-tab]'));
    function pick(t) {
      tabs.forEach(function (o) {
        var on = o === t;
        o.setAttribute('aria-selected', on ? 'true' : 'false');
        o.tabIndex = on ? 0 : -1;
        var p = document.getElementById(o.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { pick(t); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, d = (k === 'ArrowRight' || k === 'ArrowDown') ? 1 : (k === 'ArrowLeft' || k === 'ArrowUp') ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var n = tabs[(i + d + tabs.length) % tabs.length];
        n.focus(); pick(n);
      });
    });
  }

  function initCard(card) {
    var cb = card.querySelector('[data-vh-subcb]');
    var price = card.querySelector('[data-vh-price]');
    var was = card.querySelector('[data-vh-was]');
    var one = +card.getAttribute('data-price'), sub = +card.getAttribute('data-sub-price');
    function render() {
      var on = cb && cb.checked;
      price.textContent = fmt(on ? sub : one);
      if (was) was.hidden = !on;
    }
    if (cb) { cb.checked = false; cb.addEventListener('change', render); }
    render();
    var btn = card.querySelector('[data-vh-add]');
    if (btn) btn.addEventListener('click', function () {
      var item = { id: +card.getAttribute('data-variant'), quantity: 1 };
      if (cb && cb.checked && card.getAttribute('data-plan')) item.selling_plan = +card.getAttribute('data-plan');
      add([item], btn);
    });
  }

  function initBundle(card) {
    var btn = card.querySelector('[data-vh-add]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var ids = (card.getAttribute('data-variants') || '').split(',').filter(Boolean);
      var name = card.getAttribute('data-name') || '';
      add(ids.map(function (id) { return { id: +id, quantity: 1, properties: { _bundle: name } }; }), btn, card.getAttribute('data-code') || '');
    });
  }

  function initPerks(sec) {
    sec.querySelectorAll('[data-vh-code]').forEach(function (b) {
      b.addEventListener('click', function () {
        var c = b.getAttribute('data-vh-code');
        applyCode(c).then(function () {
          b.classList.add('is-applied'); b.setAttribute('aria-pressed', 'true'); b.textContent = c + ' applied ✓';
          refreshCart();
        });
      });
    });
    sec.querySelectorAll('[data-vh-suball]').forEach(function (b) {
      b.addEventListener('click', function () {
        var shop = document.getElementById('shop');
        if (!shop) return;
        var t = shop.querySelector('[data-vh-tab]');
        if (t && t.getAttribute('aria-selected') !== 'true') t.click();
        shop.querySelectorAll('[data-vh-subcb]').forEach(function (cb) {
          if (!cb.checked) { cb.checked = true; cb.dispatchEvent(new Event('change')); }
        });
      });
    });
  }

  function initReviews(row) {
    if (!row.hasAttribute('data-auto')) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var paused = false, pos = row.scrollLeft, resume;
    function pause() { paused = true; clearTimeout(resume); }
    function later() { clearTimeout(resume); resume = setTimeout(function () { pos = row.scrollLeft; paused = false; }, 2500); }
    row.addEventListener('pointerenter', pause); row.addEventListener('pointerleave', later);
    row.addEventListener('touchstart', pause, { passive: true }); row.addEventListener('touchend', later);
    row.addEventListener('focusin', pause); row.addEventListener('focusout', later);
    (function step() {
      if (!row.isConnected) return;
      if (!paused && row.scrollWidth > row.clientWidth + 4) {
        pos += 0.35;
        if (pos >= row.scrollWidth - row.clientWidth - 1) pos = 0;
        row.scrollLeft = pos;
      }
      requestAnimationFrame(step);
    })();
  }

  function initVid(fig) {
    var v = fig.querySelector('video'), b = fig.querySelector('.vh-vid__play');
    if (!v || !b) return;
    b.addEventListener('click', function () {
      document.querySelectorAll('[data-vh-vid] video').forEach(function (o) { if (o !== v) { o.pause(); o.closest('[data-vh-vid]').classList.remove('is-playing'); o.controls = false; } });
      v.muted = false; v.controls = true; fig.classList.add('is-playing');
      var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
    });
    v.addEventListener('ended', function () { fig.classList.remove('is-playing'); v.controls = false; });
  }

  function once(sel, fn) {
    document.querySelectorAll(sel).forEach(function (el) { if (el.__vhInit) return; el.__vhInit = true; fn(el); });
  }
  function boot() {
    once('[data-vh-tabs]', initTabs);
    once('[data-vh-card]', initCard);
    once('[data-vh-bundle]', initBundle);
    once('[data-vh-perks]', initPerks);
    once('[data-vh-reviews]', initReviews);
    once('[data-vh-vid]', initVid);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
